import { isUndefined } from 'lodash';

import { ArchivedFilterOptions } from 'common/helpers/utils';
import { FilterData } from 'common/helpers/url';

import { PaginationView } from '../models/paginationModel';

/**
 * Views whose endpoint filters on `archived` rather than `show_archived`.
 *
 * The shared archive dropdown stores the user's choice as `showArchived`, which
 * generateFilterQueryParams sends as `show_archived`. The endpoints below only
 * declare `archived`, and django-filter ignores parameters it does not declare,
 * so for them the choice has to travel as `archived`.
 *
 * Only BenefitTemplates (SharedBenefitViewSet / SharedBenefitFilterSet) is listed.
 * EditEmployees (ProfileFilterSet) and the Filters tabs (GenericFilterSet) have the
 * same mismatch but are deliberately left for their own change.
 */
export const ARCHIVED_PARAM_VIEWS: readonly PaginationView[] = [PaginationView.BenefitTemplates];

/**
 * Renames the stored archive choice to `archived` as the request is built:
 * Archived -> archived=true, Unarchived -> archived=false, and All (or any other
 * value) -> no parameter, which is what All means to a BooleanFilter. Every other
 * view, and a view with no stored choice, is returned untouched.
 */
export const withArchivedParam = (
    view: PaginationView,
    filters?: FilterData,
): FilterData | undefined => {
    if (!filters || isUndefined(filters.showArchived) || !ARCHIVED_PARAM_VIEWS.includes(view)) {
        return filters;
    }

    const { showArchived, ...rest } = filters;

    return {
        ...rest,
        archived:
            showArchived === true || showArchived === ArchivedFilterOptions.Archived
                ? true
                : showArchived === false || showArchived === ArchivedFilterOptions.Unarchived
                ? false
                : undefined,
    };
};
